import React from 'react';
import { LayoutDashboard, Users, PhoneCall, BarChart3, Settings } from 'lucide-react';

const NAV_ITEMS = [
  { value: 'dashboard', label: 'Overview', icon: LayoutDashboard, testId: 'org-nav-dashboard' },
  { value: 'farmers',   label: 'Farmers',  icon: Users,         testId: 'org-nav-farmers' },
  { value: 'requests',  label: 'Requests', icon: PhoneCall,     testId: 'org-nav-requests' },
  { value: 'analytics', label: 'Analytics',icon: BarChart3,     testId: 'org-nav-analytics' },
  { value: 'settings',  label: 'Settings', icon: Settings,      testId: 'org-nav-settings' },
];

export default function OrgBottomNav({ active, onChange }) {
  return (
    <div
      className="fixed bottom-3 left-1/2 -translate-x-1/2 w-[calc(100%-24px)] max-w-[420px] md:max-w-[520px] lg:max-w-[560px] bg-white/85 backdrop-blur-2xl border border-[#E4E8EF] rounded-full shadow-[0_16px_40px_-16px_rgba(11,22,32,0.18),0_2px_6px_-2px_rgba(11,22,32,0.06)] pb-[env(safe-area-inset-bottom)] px-2 py-1.5 flex justify-around items-center z-[9999]"
      data-testid="org-bottom-nav"
    >
      {NAV_ITEMS.map((item) => {
        const isActive = active === item.value;
        const Icon = item.icon;
        return (
          <button
            key={item.value}
            data-testid={item.testId}
            onClick={() => onChange(item.value)}
            className={`relative flex flex-col items-center gap-0.5 py-1.5 px-2 rounded-full transition-all duration-200 flex-1 ${
              isActive ? 'text-[#0B4F3F]' : 'text-[#5B6675] hover:text-[#0B1620]'
            }`}
          >
            <Icon className="w-[18px] h-[18px]" strokeWidth={isActive ? 2.4 : 1.6} />
            <span className={`text-[10px] ${isActive ? 'font-semibold' : 'font-medium'}`}>{item.label}</span>
            {isActive && (
              <span className="absolute -bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-[#0B4F3F] shadow-[0_0_6px_rgba(11,79,63,0.6)]" />
            )}
          </button>
        );
      })}
    </div>
  );
}
